
module.exports=
{
    comparesolarmarket:["www.comparesolarmarket.mysolarcompare.com.au","comparesolarmarket.mysolarcompare.com.au","www.nsw.mysolarcompare.com.au","nsw.mysolarcompare.com.au"]
}